import { API } from '@config';
import { CommunityEducationalResourcesTable } from '@src/types/CommunityEducationalResources';

export const getCommunityEducationalResources = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/community-educational-resources?populate=File&sort=id%3Adesc`, options);
  const data: CommunityEducationalResourcesTable = await response.json();

  return data;
};
